import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from 'react';
const PlusCircleFilledIcon = _ref => {
  let {
      size = 24,
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    d: "M18 9.875C18 14.8456 13.9706 18.875 9 18.875C4.02944 18.875 0 14.8456 0 9.875C0 4.90444 4.02944 0.875 9 0.875C13.9706 0.875 18 4.90444 18 9.875ZM9.5625 5.9375C9.5625 5.62684 9.31066 5.375 9 5.375C8.68934 5.375 8.4375 5.62684 8.4375 5.9375V9.3125H5.0625C4.75184 9.3125 4.5 9.56434 4.5 9.875C4.5 10.1857 4.75184 10.4375 5.0625 10.4375H8.4375V13.8125C8.4375 14.1232 8.68934 14.375 9 14.375C9.31066 14.375 9.5625 14.1232 9.5625 13.8125V10.4375H12.9375C13.2482 10.4375 13.5 10.1857 13.5 9.875C13.5 9.56434 13.2482 9.3125 12.9375 9.3125H9.5625V5.9375Z",
    fill: color
  }));
};
export default PlusCircleFilledIcon;